import { recsApi } from "../services/recommendations";
import { excludeEmptyResults } from "../utils.js";
import { useSelector, shallowEqual } from "react-redux";
import get from "lodash/get";

const useFetchItems = (type) => {
  const userId = useSelector((state) => state.user?.userId, shallowEqual);

  const fetcher = get(recsApi, `useGet${type}Query`);
  const { data, error, isFetching } = fetcher(userId);

  return error || isFetching ? [] : excludeEmptyResults(data.data);
};

export default useFetchItems;
